<template>
	<div class="w-full flex flex-col pb-48 bg-stone-100 dark:bg-stone-700">
		<div class="w-full flex flex-col">
			<div class="px-4 dark:text-stone-100">
				<div v-if="this.$store.state?.user?.role === 'transporter'" class="px-8 mx-4 text-md flex flex-col gap-4">
					<div class="text-3xl">
						Управляй своей поездкой вместе с <b>Sultan TAXI</b>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">1.</div>
						<div>Выберете междугородний маршрут город отправления и назначения</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">2.</div>
						<div>Определите время, когда планируется выезд по маршруту</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">3.</div>
						<div>Укажите количество свободных мест, наличие свободного багажника</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">4.</div>
						<div>Укажите цену за предложение</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">5.</div>
						<div>Нажмите кнопку подать заявку</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">6.</div>
						<div class="flex items-center flex-wrap">После подачи заявки по маршруту <img :src="require('@/assets/create_offer_icon.png')" class="h-6 w-6 mx-2" /> откроется возможность созвониться с попутчиками <img :src="require('@/assets/wavingman.png')" class="h-6 w-6 mx-2" />. Это поможет вам найти подходящих пассажиров</div>
					</div>
				</div>
				<div v-else class="px-8 mx-4 text-md flex flex-col gap-4">
					<div class="text-3xl">
						Управляй своей поездкой вместе с <b>Sultan TAXI</b>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">1.</div>
						<div>Выберете междугородний маршрут город отправления и назначения</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">2.</div>
						<!-- <div>Выберете подходящую Вам заявку Водителей</div> -->
						<div class="flex items-center flex-wrap">Добавьте заказ по маршруту <img :src="require('@/assets/create_offer_icon.png')" class="h-6 w-6 mx-2" /> или выберите подходящую заявку от водителей.</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">3.</div>
						<div>Вы всегда можете отказаться от предложений ( например, если предлагают другого водителя или другое транспортное средство)
						</div>
					</div>
					<div class="flex items-center gap-2">
						<div class="text-2xl font-semibold">4.</div>
						<div>По завершению поездки оставьте Ваш отзыв, (Каждый отзыв важен для улучшения качества обслуживания)
						</div>
					</div>
				</div>
				<div class="border-t h-2 m-4"></div>
				<div class="flex flex-row w-full justify-center px-4 fixed bottom-24 left-0">
					<a href="whatsapp://send?text=https://sultantaxi.kz/ Междугородние поездки с SultanTAXI!" data-action="share/whatsapp/share" class="flex flex-row items-center text-emerald-800 font-semibold text-2xl gap-6 py-4 px-4 bg-emerald-300 justify-center rounded-md">
						<img src="https://i.pinimg.com/474x/6e/69/25/6e69252a910770fbd9d3ddef65d1d5a4.jpg"  class="rounded-full h-12"/>
						<div>Поделиться в WhatsApp</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'DashboardHome',
    methods: {
	}
}
</script>
